import React, { useState, useEffect } from 'react';

const FloatingOverlay = () => {
  const [messages, setMessages] = useState([]);
  const [isTranscribing, setIsTranscribing] = useState(false);

  useEffect(() => {
    window.electron?.ipcRenderer.on('new-message', (event, data) => {
      setMessages(prev => [
        {
          sender: 'ai',
          message: data.answer,
          time: new Date().toLocaleTimeString()
        },
        {
          sender: 'interviewer',
          message: data.question,
          time: new Date().toLocaleTimeString()
        },
        ...prev
      ]);
    });

    window.electron?.ipcRenderer.on('transcribing-status', (event, status) => {
      setIsTranscribing(status);
    });

    return () => {
      window.electron?.ipcRenderer.removeAllListeners('new-message');
      window.electron?.ipcRenderer.removeAllListeners('transcribing-status');
    };
  }, []);

  return (
    <div style={{
      background: 'rgba(10, 10, 20, 0.88)',
      backdropFilter: 'blur(12px)',
      height: '100vh',
      borderRadius: '12px',
      border: '1px solid rgba(147,112,219,0.3)',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      color: 'white',
      fontFamily: 'Arial, sans-serif',
      userSelect: 'none'
    }}>

      {/* Draggable Header */}
      <div style={{
        WebkitAppRegion: 'drag',
        padding: '10px 14px',
        background: 'rgba(147,112,219,0.25)',
        borderBottom: '1px solid rgba(147,112,219,0.3)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0
      }}>
        <span style={{ fontWeight: 'bold', color: '#e0a3ff', fontSize: '13px' }}>
          🎯 Terview AI
        </span>
        <span style={{
          fontSize: '11px',
          color: isTranscribing ? '#00ff88' : '#888',
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}>
          <span style={{
            width: '7px',
            height: '7px',
            borderRadius: '50%',
            background: isTranscribing ? '#00ff88' : '#888',
            display: 'inline-block'
          }}></span>
          {isTranscribing ? 'Transcribing...' : 'Ready'}
        </span>
      </div>

      {/* Messages List */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}>
        {messages.length === 0 ? (
          <div style={{
            color: '#666',
            fontSize: '13px',
            textAlign: 'center',
            marginTop: '30px',
            lineHeight: '1.8'
          }}>
            <div style={{ fontSize: '24px', marginBottom: '8px' }}>🎤</div>
            Waiting for interview questions...
          </div>
        ) : (
          messages.map((msg, idx) => (
            <div key={idx} style={{
              background: msg.sender === 'interviewer'
                ? 'rgba(255,105,180,0.1)'
                : 'rgba(147,112,219,0.15)',
              borderLeft: `3px solid ${msg.sender === 'interviewer' ? '#ff69b4' : '#9370db'}`,
              borderRadius: '8px',
              padding: '9px 11px',
              fontSize: '12.5px',
              lineHeight: '1.6'
            }}>
              <div style={{
                fontSize: '10px',
                color: msg.sender === 'interviewer' ? '#ff69b4' : '#9370db',
                fontWeight: 'bold',
                marginBottom: '4px',
                display: 'flex',
                justifyContent: 'space-between'
              }}>
                <span>{msg.sender === 'interviewer' ? '🎤 Interviewer' : '💡 Suggested Answer'}</span>
                <span style={{ color: '#555', fontWeight: 'normal' }}>{msg.time}</span>
              </div>
              <div style={{ color: '#eee' }}>{msg.message}</div>
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      <div style={{
        padding: '8px 14px',
        borderTop: '1px solid rgba(147,112,219,0.2)',
        fontSize: '11px',
        color: '#555',
        textAlign: 'center',
        flexShrink: 0
      }}>
        Drag to move • Answers auto-appear
      </div>
    </div>
  );
};

export default FloatingOverlay;